import { speakersPalette, SpeakersPaletteTokens, Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

type SpaceColorCircleProps = {
  colorToken: SpeakersPaletteTokens;
};

export const SpaceColorCircle = ({ colorToken }: SpaceColorCircleProps) => (
  <Stack
    alignItems="center"
    bgcolor={speakersPalette[colorToken]?.[100]}
    borderRadius={6}
    color={speakersPalette?.[colorToken]?.[600]}
    height={24}
    justifyContent="center"
    width={24}
  >
    <Typography color="inherit" fontSize={20} sx={{ transform: 'translateY(-0.5px)' }} variant="caption-1-md">
      ○
    </Typography>
  </Stack>
);
